// import React from "react";

// function ForgotPassword() {
//   return <div>ForgotPassword</div>;
// }

// export default ForgotPassword;


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import LoginRegisterBanner from "../../../layout/assets/images/Login/login-register-banner.svg"; // Replace with your image import
import SnackbarAlert from "../../common/sanckbar";
import { sendOtp, verifyOtp, resetPassword } from "../../../utils/api";


export function ForgotPassword() {
  const [step, setStep] = useState<"email" | "otp" | "password">("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"success" | "error">("error");
  const [snackbar, setSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

 

  // Snackbar Handler
  const showAlert = (message: string, severity: "success" | "error") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setSnackbar(true);
  };

  const closeSnackbar = () => setSnackbar(false);

  // **Handle Email Submission**
  const handleEmailSubmit = async () => {
    if (!email.includes("@")) {
      showAlert("Invalid email format", "error");
      return;
    }
    setLoading(true);
    try {
       const response = await sendOtp("sendOtp", {
              email: email,
            });
            console.log("response", response)
            if(response.status == true){
              showAlert("OTP sent successfully", "success");
              setStep("otp");
            }else{
              showAlert("Something went wrong", "error");      
            }
    } catch {
      showAlert("Failed to send OTP", "error");
    }
    setLoading(false);
  };

  // **Handle OTP Submission**
  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      showAlert("OTP must be 6 digits", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await verifyOtp("verifyOtp", {
        email: email,
        otp:otp
      });
      console.log("response", response)
      if(response.status == true){
        showAlert("OTP verified successfully", "success");
        setStep("password");
      }else{
        showAlert("Something went wrong", "error");

      }
     
    } catch {
      showAlert("Invalid OTP", "error");
    }
    setLoading(false);
  };

  // **Handle Password Submission**
  const handlePasswordSubmit = async () => {
    if (newPassword.length < 6) {
      showAlert("Password must be at least 6 characters", "error");
      return;
    }
    if (newPassword !== confirmPassword) {
      showAlert("Passwords do not match", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await resetPassword("resetPassword", {
        password: newPassword,
        email : email
      });
      console.log("response", response)
      if(response.status == true){
        showAlert("Password reset successful!", "success");
        navigate("/dashboard");
      }else{
        showAlert("Something went wrong", "error");

      }
     
    } catch {
      showAlert("Failed to reset password", "error");
    }
    setLoading(false);
  };

  return (
    <>
      <SnackbarAlert open={snackbar} closeSnackbar={closeSnackbar} message={alertMessage} severity={alertSeverity} />
      <div className="row login-page">
        {/* Left Side Image */}
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 login-rt-cntnr">
          <img src={LoginRegisterBanner} alt="Forgot Password" className="w-100" />
        </div>

        {/* Right Side Form */}
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
          <div>
            <div className="logo-cntr">
              <span className="company-name-first-part"> Nautai Marine </span>
              <span className="company-name-second-part"> - Admin</span>
            </div>
            <h1 className="heading login-heading">Forgot Password</h1>

            {/* Email Step */}
            {step === "email" && (
              <div>
                <TextField
                  className="form email-field"
                  label="Enter your Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <br />
                <Button className="login-btn" onClick={handleEmailSubmit} disabled={loading}>
                  {loading ? "Sending OTP..." : "Send OTP"}
                </Button>
              </div>
            )}

            {/* OTP Step */}
            {step === "otp" && (
              <div>
                <TextField
                  className="form otp-field"
                  label="Enter OTP"
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <br />
                <Button className="login-btn" onClick={handleOtpSubmit} disabled={loading}>
                  {loading ? "Verifying OTP..." : "Verify OTP"}
                </Button>
              </div>
            )}

            {/* Password Reset Step */}
            {step === "password" && (
              <div>
                <TextField
                  className="form password-field"
                  label="New Password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <br />
                <TextField
                  className="form password-field"
                  label="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <br />
                <Button className="login-btn" onClick={handlePasswordSubmit} disabled={loading}>
                  {loading ? "Resetting..." : "Reset Password"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

